import React from "react";
import { Icon } from "semantic-ui-react";

const FetchingSpinner = ({ text = "Fetching...", inline = false, light = false }) => {
  const spinnerColor = light ? '#ffffff' : undefined;
  const textColor = light ? '#ffffff' : '#1f2937';
  if (inline) {
    return (
      <span className="d-inline-flex align-items-center" style={{ gap: '8px' }}>
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
          style={{
            width: '1em',
            height: '1em',
            borderWidth: '0.15em',
            color: 'currentColor',
            flexShrink: 0
          }}
        />
        {text && <span style={{ fontSize: '14px', fontWeight: 600 }}>{text}</span>}
      </span>
    );
  }
  return (
    <div className="mx-0 px-3 py-5 h-100 w-100" style={light ? { color: spinnerColor } : undefined}>
      <div className="d-flex flex-column align-items-center justify-content-center w-100" style={{ gap: '16px' }}>
        {light ? (
          <span
            className="spinner-border"
            role="status"
            aria-hidden="true"
            style={{
              width: '2.5rem',
              height: '2.5rem',
              borderWidth: '0.2em',
              color: spinnerColor
            }}
          />
        ) : (
          <Icon name="spinner" loading size="large" />
        )}
        {text && <h6 style={{ margin: 0, fontSize: '14px', fontWeight: 600, color: textColor }}>{text}</h6>}
      </div>
    </div>
  );
};

export default FetchingSpinner;
